import { TableConfig } from '@shared/interfaces/table/table-config';
import { MeteringPointCalculationStructureDto } from '@app/api/dmc';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { validFromPartialTable } from '@shared/partials/validfrom-partial.table';
import { validToPartialTable } from '@shared/partials/validto-partial.table';
import { htxPartialTable } from '@shared/partials/htx-partial.table';

export const meteringpointCalculationStructureTable: TableConfig<MeteringPointCalculationStructureDto> = {
  selectable: true,
  selectableType: 'single',
  columns: [
    {
      title: 'Beregningsalgoritme',
      key: 'calculationStructureDisplayName'
    },
    validFromPartialTable,
    validToPartialTable,
    datahubPartial,
    htxPartialTable,
  ]
};
